import * as React from 'react'
import { observer } from 'mobx-react'
import { SideSheetElevation, SideSheetHostView } from 'components/SideSheet'
import OpportunitiesViewModel from 'opportunities/OpportunitiesViewModel'
import OpportunityDetailsSheet from '../OpportunityDetailsSheet'

interface GlobalOpportunityDetailsSheetContainerProps {
  vm: OpportunitiesViewModel
}

/**
 * Hosted at the top of the tree, this will be used as the Op Details viewer when an Op is selected.
 * For example, if a notification comes in of a New Op, rather than redirect the user to Ops, we show
 * the sheet above the current page.
 */
export default observer(function GlobalOpportunityDetailsSheet({
  vm,
}: GlobalOpportunityDetailsSheetContainerProps) {
  const visible = !vm.isActive && !!vm.detailsVM.selected
  return (
    <SideSheetHostView
      mainless
      onRequestHide={vm.detailsVM.deselect}
      elevation={SideSheetElevation.Above}
      sheetVisible={visible}
    >
      <OpportunityDetailsSheet
        onCloseClick={vm.detailsVM.deselect}
        vm={vm.detailsVM}
      />
    </SideSheetHostView>
  )
})
